import React from 'react';
import Tooltip from 'rc-tooltip';

import styles from './fundProfileSectionHeaderStyles';

import Icon from 'buyside/components/presentation/Icon/icon';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import ProgressBar from 'buyside/components/presentation/ProgressBar/progressBar';
import VisibilityForm from 'buyside/components/presentation/FundProfileShowPage/FundProfileForm/VisibilityForm/visibilityForm';

import PencilIcon from 'buyside/svgs/pencil.svg';
import ArrowsUpDownIcon from 'buyside/svgs/arrows_up_down.svg';
import LockIcon from 'buyside/svgs/lock.svg';
import PercentIcon from 'buyside/svgs/percent.svg';

import { ALLOCATOR, FILTERED_ALLOCATOR } from 'buyside/util/fundProfileConstants';
import { newResearchUrl } from 'buyside/util/urlHelper';

const FundProfileSectionHeader = ({
  icon,
  title,
  tip,
  section,
  sectionVisibility,
  sectionCompletenessPercent,
  sectionExcluded,
  openEditModal,
  openReorderModal,
  roleIsAdmin,
  openBlocklistModal,
  fundProfileId
}) => {
  const visibilityForm = (
    <VisibilityForm
      openBlocklistModal={openBlocklistModal}
      sectionVisibility={sectionVisibility}
      section={section}
      fundProfileId={fundProfileId}
    />
  );
  const tipButton = tip && (
    <Button
      className={styles.sectionHeaderTip}
      text={tip}
      type={BUTTON_TYPES.LINK}
      onClick={openEditModal}
      url={!openEditModal && newResearchUrl()}
    />
  );
  const visibilityText = (sectionVisibility => {
    switch (sectionVisibility) {
      case ALLOCATOR:
        return 'Allocators';
      case FILTERED_ALLOCATOR:
        return 'Filtered Allocators';
      default:
        return 'Community';
    }
  })(sectionVisibility);
  return (
    <div className={styles.sectionHeader}>
      <div className={styles.sectionHeaderMainRow}>
        <div className={styles.sectionHeaderHeading}>
          <Icon type={icon} />
          <span>{title}</span>
        </div>
        <div className={styles.sectionHeaderEditButtons}>
          {roleIsAdmin && openEditModal && (
            <Button
              text="Edit"
              onClick={openEditModal}
              className={styles.sectionHeaderEditButton}
              type={BUTTON_TYPES.LINK}
              icon={PencilIcon}
              iconStyle={styles.editButtonIcon}
            />
          )}
          {roleIsAdmin && openReorderModal && (
            <Button
              text="Reorder"
              onClick={openReorderModal}
              className={styles.sectionHeaderEditButton}
              type={BUTTON_TYPES.LINK}
              icon={ArrowsUpDownIcon}
              iconStyle={styles.editButtonIcon}
            />
          )}
        </div>
      </div>
      {roleIsAdmin && (
        <div className={styles.sectionHeaderInfo}>
          <div className={styles.sectionHeaderInfoItem}>
            <LockIcon className={styles.sectionHeaderIcon} />
            <strong>Section Privacy</strong>
            :&nbsp;
            <Tooltip destroyTooltipOnHide overlay={visibilityForm} trigger="click">
              <Button
                className={styles.sectionHeaderVisibilityButton}
                text={visibilityText}
                type={BUTTON_TYPES.LINK}
                disabled={!sectionVisibility}
              />
            </Tooltip>
          </div>
          {!isNaN(sectionCompletenessPercent) && !sectionExcluded && (
            <div className={styles.sectionHeaderInfoItem}>
              <PercentIcon className={styles.sectionHeaderIcon} />
              <span>
                <strong>Section Completeness</strong>: {sectionCompletenessPercent}%
              </span>
              <div className={styles.sectionHeaderProgressBarWrap}>
                <ProgressBar progress={sectionCompletenessPercent} />
              </div>
            </div>
          )}
        </div>
      )}
      {roleIsAdmin && sectionCompletenessPercent !== 100 && !!tip && (
        <div className={styles.sectionHeaderTip}>
          Instructions: {tipButton} to get the full award for this section.
        </div>
      )}
    </div>
  );
};

export default FundProfileSectionHeader;
